module.exports = __webpack_public_path__ + "static/media/ic-service.cf5f8d44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-service.svg
// module id = 664
// module chunks = 14